module.exports = __webpack_public_path__ + "0368f5606b409f3b0108e2b70211a2d4.pdf";